import React from "react";
import { connect } from "react-redux";

import Cadenced from "@mapmycustomers/shared/types/base/Cadenced";

import FrequencySelector from "@app/component/frequency/FrequencySelector";
import FrequencyPreviewConfig from "@app/component/frequency/type/FrequencyPreviewConfig";
import { getFrequencyCustomInterval } from "@app/scene/map/store/selectors";
import { getFrequencyPanelConfig } from "@app/store/frequency";
import { RootState } from "@app/store/rootReducer";

import useFrequencyContext from "../../util/useFrequencyContext";
import FrequencyInfo from "../FrequencyInfo";

import styles from "./FrequencySelectorWithConfig.module.scss";

interface FrequencySelectorWithConfigProps {
  config: FrequencyPreviewConfig;
  onChange: (cadence: Partial<Cadenced>) => void;
  savedFrequencyInterval?: Cadenced["cadenceInterval"];
}

const FrequencySelectorWithConfig = ({
  config: { entity, isGroup },
  onChange,
  savedFrequencyInterval,
}: FrequencySelectorWithConfigProps) => {
  const { isEntityFrequencyUpdating } = useFrequencyContext();

  return (
    <div className={styles.container}>
      <FrequencySelector
        entity={entity}
        frequencyIntervalValue={entity.cadenceInterval}
        isGroup={isGroup}
        onChange={onChange}
        savedFrequencyInterval={savedFrequencyInterval}
        updating={isEntityFrequencyUpdating}
      />
      <FrequencyInfo />
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  config: getFrequencyPanelConfig(state),
  savedFrequencyInterval: getFrequencyCustomInterval(state),
});

export default connect(mapStateToProps)(FrequencySelectorWithConfig);
